import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-return",
  "use": "icon-s-return-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-return\"><path fill-rule=\"evenodd\" d=\"M14 0 22 2.22044605e-16 22 15 20 15 20 14.928341 3.5633151 14.928341 9.29238536 20.6604964 7.97195344 21.9994391 0 14.0089749 7.97195344 6 9.29238536 7.33894264 3.5633151 13.0865236 20 13.0865236 20 2 14 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol